import * as Yup from "yup";
const registerValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  corporateCode: Yup.string().required("Corporate code is required"),
  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Enter a valid 10-digit mobile number")
    .required("Mobile number is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string().min(5).required("Password is required"),
});

const loginValidationSchema = Yup.object({
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[6-9]\d{9}$/, "Enter valid mobile number"),
  password: Yup.string()
    .optional(),
});

export { registerValidationSchema, loginValidationSchema };
